import { Image, Spin } from 'antd';

/**
 * Класс полноэкранного просмотра фотографий. Задаёт снимку одинаковую рамку
 * независимо от разрешения (см. styles.css) — подключается и там, где
 * просмотр открывается из галереи миниатюр, а не через PhotoViewer.
 */
export const PHOTO_VIEWER_CLASS = 'tms-photo-viewer';

interface Props {
  /** Адрес загруженного снимка; null — снимок ещё грузится. */
  src: string | null;
  onClose: () => void;
}

/**
 * Полноэкранный просмотр одного снимка, открытого из списка.
 *
 * Image.PreviewGroup с items, а не скрытый <Image>: скрытая картинка всё
 * равно оставляет в разметке обёртку .ant-image высотой в строку. На странице,
 * которая почти впритык по высоте экрана, эта строка вызывала полосу
 * прокрутки — и вся страница сужалась на её ширину в момент открытия.
 * Группа без дочерних элементов в страницу не вставляет ничего.
 */
export function PhotoViewer({ src, onClose }: Props) {
  if (!src) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1100,
          display: 'grid',
          placeItems: 'center',
          // Без затемнения: свою подложку рисует просмотрщик после загрузки,
          // два затемнения подряд дают вспышку между ними.
          background: 'transparent',
        }}
        onClick={onClose}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Image.PreviewGroup
      items={[src]}
      preview={{
        visible: true,
        rootClassName: PHOTO_VIEWER_CLASS,
        onVisibleChange: (visible) => {
          if (!visible) onClose();
        },
      }}
    />
  );
}
